import { render, staticRenderFns } from "./registerParcelStep1.vue?vue&type=template&id=177d0678&scoped=true&"
import script from "./registerParcelStep1.vue?vue&type=script&lang=js&"
export * from "./registerParcelStep1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177d0678",
  null
  
)

export default component.exports